import { useState } from 'react';
import { Modal, Col, Row, Form } from 'react-bootstrap';
import IcX from '../../components/Svg/IcX';
import styles from './style.module.css';
import { Password } from '../Input';
import Button from '../Button';
import useWrapper from '../../hooks/useWrapper';
import { toast } from 'react-toastify';
import api from '../../services/api';

export default function ModalPassword(props) {

  const { show, onHide } = props;
  const { me, config } = useWrapper();

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setloading] = useState();

  const submitPassword = async () => {
    setloading(true);
    try {
      await api.put(`trainee/trainees/${me.id}`, {
        password: password
      }, config);
      toast.success("Senha modificada com sucesso!");
      onHide();
    }
    catch (__err) {
      toast.error("Erro ao tentar modificar a senha!");
    }
    setloading(false);
  }

  return (
    <>
      <Modal size="lg" show={show} onHide={onHide}>
        <Modal.Header>
          <div as="label" className="d-flex w-100">
            <h2 className="page-title">Alterar Senha</h2>
          </div>
          <button className={styles.closeModal} onClick={onHide}>
            <IcX />
          </button>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <p className='mb-0'>Escolha a sua nova senha</p>
              <p className="small-label mt-0">Ela deve ter no mínimo de 7 caracteres. Aconselhamos o uso de números, letras e caracteres especiais.</p>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className='lince-input'>
                <span className='lince-input_label'>Nova senha</span>
                <div className='lince-input__text'>
                  <Password
                    name="password"
                    value={password}
                    autoComplete="off"
                    valueChange={ev => {
                      setPassword(ev)
                    }}
                  />
                </div>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className='lince-input'>
                <span className='lince-input_label'>Confirmar nova senha</span>
                <div className='lince-input__text'>
                  <Password
                    name="confirm"
                    value={confirm}
                    autoComplete="off"
                    valueChange={ev => {
                      setConfirm(ev)
                    }}
                  />
                </div>
              </Form.Group>
            </Col>

          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => { submitPassword(); }}
            disabled={password.length < 7 || password !== confirm}
            loading={loading}
          >
            Alterar Senha
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}